import agent from '../agent'
import Navigation from './widgets/Navigation'
import LogoutPane from './widgets/LogoutPane'
import React from 'react'
import { connect } from 'react-redux'
import { APP_LOAD, REDIRECT } from '../constants/actionTypes'
import { Route, Switch, Link } from 'react-router-dom'
import UserDetail from '../components/UserDetail'
import Users from '../components/Users'
import UserAdd from '../components/UserAdd'
import UserAccountAdd from '../components/UserAccountAdd'

import Merchants from '../components/Merchants'
import Categories from '../components/Categories'
import CategoryDetail from '../components/CategoryDetail'
import CategoryEdit from '../components/CategoryEdit'
import Products from '../components/Products'
import ProductDetail from '../components/ProductDetail'
import ProductEdit from '../components/ProductEdit'

import Accounts from '../components/Accounts'
import AccountDetail from '../components/AccountDetail'
import AccountRawDetail from '../components/AccountRawDetail'
import Coins from '../components/Coins'
import CoinTransactionDetail from '../components/CoinTransactionDetail'
import CoinSend from '../components/CoinSend'
import Logs from '../components/Logs'
import Transactions from '../components/Transactions'
import Trades from '../components/Trades'
import TradeDetail from '../components/TradeDetail'
import Withdraws from '../components/Withdraws'
import Deposits from '../components/Deposits'
import BankVerification from '../components/BankVerification'
import KycVerification from '../components/KycVerification'
import GeminiOrders from '../components/GeminiOrders'
import UserTasks from '../components/UserTasks'
import Home from '../components/Home'
import Login from '../components/Login'

import EthCommitUsers from '../components/EthCommitUsers'
import EthCommitTransactions from '../components/EthCommitTransactions'
import BtcCommitUsers from '../components/BtcCommitUsers'
import BtcCommitTransactions from '../components/BtcCommitTransactions'
import Signature from '../components/Signature'

import Contracts from '../components/Contracts'
import ContractAdd from '../components/ContractAdd'
import ContractDetail from '../components/ContractDetail'
import MasterAccounts from '../components/MasterAccounts'
import MasterAccountAdd from '../components/MasterAccountAdd'
import MasterAccountUpdate from '../components/MasterAccountUpdate'
import MasterAccountDetail from '../components/MasterAccountDetail'
import MasterAccountMint from '../components/MasterAccountMint'

import Channels from './Channels'
import ChannelDetail from '../components/ChannelDetail'
import ChannelAdd from '../components/ChannelAdd'
import ChannelEdit from '../components/ChannelEdit'
import PostDetail from '../components/PostDetail'
import DepositWithReferenceCode from '../components/DepositWithReferenceCode'
import Verification from '../components/Verification'
import Rates from '../components/Rates'
import RateAdd from '../components/RateAdd'
import RateUpdate from '../components/RateUpdate'

import Tokens from '../components/Tokens'
import TokenAdd from '../components/TokenAdd'
import TokenDetail from '../components/TokenDetail'
import TokenFees from '../components/TokenFees'
import TokenAdmins from '../components/TokenAdmins'
import VerifiyPin from '../components/VerifiyPin'

import { store } from '../store'
import { push } from 'react-router-redux'
import { BASE_COIN_SYMBOL, API_ROOT_URL, COIN_MASTER_ADDRESS } from '../constants/config'
import { Helmet } from "react-helmet"

import role from '../util/role';
import {
  LOGIN,
  USER_LIST_PAGE_LOADED,
  ACCOUNT_GO,
  COIN_LIST_PAGE_LOADED,
  CONTRACT_LIST_PAGE_LOADED,
  MASTER_ACCOUNT_LIST_PAGE_LOADED,
  TASK_WITHDRAW_LOADED,
  TASK_DEPOSIT_LOADED,
  TASK_VERIFICATION_LOADED,
  TASK_KYC_LOADED,
  TASK_GEMINIORDERS_LOADED,
  TRANSACTION_LIST_PAGE_LOADED,
  TRADE_LIST_PAGE_LOADED,
  LOG_LIST_PAGE_LOADED,
  SIGNATURE_PAGE_LOADED,
  ETH_COMMIT_USER_LIST_PAGE_LOADED,
  BTC_COMMIT_USER_LIST_PAGE_LOADED,
  CHAT_CHANNEL_LIST_PAGE_LOADED,
  DEPOSIT_BANK_REFERENCE_CODE_SUBMIT,
  USER_TASK_LIST_LOADED,
  CATEGORY_LIST_PAGE_LOADED,
  CATEGORY_DETAIL_PAGE_LOADED,
  CATEGORY_UPDATE_LOADED,
  PRODUCT_LIST_PAGE_LOADED,
  PRODUCT_DETAIL_PAGE_LOADED,
  PRODUCT_UPDATE_LOADED,
  RATES_PAGE_LOADED,
  RATE_CREATE_PAGE_LOADED,
  RATE_UPDATE_PAGE_LOADED,
  TOKEN_LIST_PAGE_LOADED,
  TOKEN_DETAIL_PAGE_LOADED,
  TOKEN_CREATE,
  TOKEN_APPROVE,
  TOKEN_UPDATE
} from '../constants/actionTypes'

const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo
  }
}

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, token) =>
    dispatch({ type: APP_LOAD, payload, token, skipTracking: true }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class App extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      // this.context.router.replace(nextProps.redirectTo)
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }

  componentWillMount() {
    const token = window.localStorage.getItem('badmin-jwt')
    if (token) {
      agent.setToken(token)
    }
    const payload = Promise.all([
      agent.Common.getCountries(),
      token ? agent.Auth.current() : null
    ])
    this.props.onLoad(payload)
  }

  render() {
    if (this.props.appLoaded) {

      const userRole = this.props.currentUser ? (this.props.currentUser.role || 0) : 0;
      const icoUrl = `/favicon/favicon.ico`
      const clientCSSUrl = `/style/${BASE_COIN_SYMBOL.toLowerCase()}.css`
      let applicationVersion

      try { applicationVersion = process.env.npm_package_version || require('../../package.json').version } catch (err) { applicationVersion = 'N/A' }

      return (
        <div id='wrapper'>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Telkom Pay Admin</title>
            <link rel="canonical" href="/" />
            <link rel="icon" type="image/x-icon" sizes="16x16" href={icoUrl} />
            <link rel="stylesheet" href="/style/main.css?v106" />
            <link href="https://fonts.googleapis.com/css?family=Noto+Sans" rel="stylesheet" type="text/css" />
            <link href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" rel="stylesheet" type="text/css" />
          </Helmet>
          <div id="header">
            <Link to="/"><h1>Telkom Pay - {this.props.appName}</h1></Link>
          </div>
          <Navigation currentUser={this.props.currentUser} />
          <div id='menu-bg'></div>
          <div id="main">
            <Switch>
              {role.can(userRole, LOGIN) ? <Route exact path="/" component={Home} /> : null}
              <Route path="/login" component={Login} />
              <Route path="/verification" component={Verification} />
              <Route path='/verifypin' component={VerifiyPin} />

              {role.can(userRole, SIGNATURE_PAGE_LOADED) ? <Route path="/signature" component={Signature} /> : null}
              {role.can(userRole, USER_LIST_PAGE_LOADED) ? <Route path="/users/:key/accounts/create" component={UserAccountAdd} /> : null}
              {role.can(userRole, USER_LIST_PAGE_LOADED) ? <Route path="/users/create" component={UserAdd} /> : null}
              {role.can(userRole, USER_LIST_PAGE_LOADED) ? <Route path="/users/:key" component={UserDetail} /> : null}
              {role.can(userRole, USER_LIST_PAGE_LOADED) ? <Route path="/users" component={Users} /> : null}

              {role.can(userRole, USER_LIST_PAGE_LOADED) ? <Route path="/merchants" component={Merchants} /> : null}
              {role.can(userRole, CATEGORY_LIST_PAGE_LOADED) ? <Route path="/categories/user/:key" component={Categories} /> : null}
              {role.can(userRole, CATEGORY_DETAIL_PAGE_LOADED) ? <Route path="/category/:key/detail" component={CategoryDetail} /> : null}
              {role.can(userRole, CATEGORY_UPDATE_LOADED) ? <Route path="/category/:key/edit" component={CategoryEdit} /> : null}
              {role.can(userRole, PRODUCT_LIST_PAGE_LOADED) ? <Route path="/products/user/:key" component={Products} /> : null}
              {role.can(userRole, PRODUCT_DETAIL_PAGE_LOADED) ? <Route path="/product/:key/detail" component={ProductDetail} /> : null}
              {role.can(userRole, PRODUCT_UPDATE_LOADED) ? <Route path="/product/:key/edit" component={ProductEdit} /> : null}

              {role.can(userRole, ACCOUNT_GO) ? <Route path="/accounts/raw/:address" component={AccountRawDetail} /> : null}
              {role.can(userRole, ACCOUNT_GO) ? <Route path="/accounts/:key" component={AccountDetail} /> : null}
              {role.can(userRole, ACCOUNT_GO) ? <Route path="/accounts" component={Accounts} /> : null}
              {role.can(userRole, COIN_LIST_PAGE_LOADED) ? <Route path="/coins/transactions/:key" component={CoinTransactionDetail} /> : null}
              {role.can(userRole, COIN_LIST_PAGE_LOADED) ? <Route path="/coins/send" component={CoinSend} /> : null}
              {role.can(userRole, COIN_LIST_PAGE_LOADED) ? <Route path="/coins" component={Coins} /> : null}
              {role.can(userRole, LOG_LIST_PAGE_LOADED) ? <Route path="/logs" component={Logs} /> : null}
              {role.can(userRole, TASK_WITHDRAW_LOADED) ? <Route path="/tasks/withdraws" component={Withdraws} /> : null}
              {role.can(userRole, TASK_DEPOSIT_LOADED) ? <Route path="/tasks/deposits" component={Deposits} /> : null}
              {role.can(userRole, TASK_VERIFICATION_LOADED) ? <Route path="/tasks/verification" component={BankVerification} /> : null}
              {role.can(userRole, TASK_KYC_LOADED) ? <Route path="/tasks/kyc" component={KycVerification} /> : null}
              {role.can(userRole, TASK_GEMINIORDERS_LOADED) ? <Route path="/tasks/gemini" component={GeminiOrders} /> : null}
              {role.can(userRole, USER_TASK_LIST_LOADED) ? <Route path="/tasks/user/:key" component={UserTasks} /> : null}
              {role.can(userRole, TRADE_LIST_PAGE_LOADED) ? <Route path="/trades" component={Trades} /> : null}
              {role.can(userRole, TRADE_LIST_PAGE_LOADED) ? <Route path="/trade/detail/:key" component={TradeDetail} /> : null}
              {role.can(userRole, TRANSACTION_LIST_PAGE_LOADED) ? <Route path="/transactions" component={Transactions} /> : null}

              {role.can(userRole, ETH_COMMIT_USER_LIST_PAGE_LOADED) ? <Route path="/ethcommitusers" component={EthCommitUsers} /> : null}
              {role.can(userRole, ETH_COMMIT_USER_LIST_PAGE_LOADED) ? <Route path="/user/:key/ethcommit/transactions" component={EthCommitTransactions} /> : null}
              {role.can(userRole, BTC_COMMIT_USER_LIST_PAGE_LOADED) ? <Route path="/btccommitusers" component={BtcCommitUsers} /> : null}
              {role.can(userRole, BTC_COMMIT_USER_LIST_PAGE_LOADED) ? <Route path="/user/:key/btccommit/transactions" component={BtcCommitTransactions} /> : null}

              {role.can(userRole, TOKEN_CREATE) ? <Route path="/tokens/create" component={TokenAdd} /> : null}
              {role.can(userRole, TOKEN_LIST_PAGE_LOADED) ? <Route path="/tokens/admins" component={TokenAdmins} /> : null}
              {role.can(userRole, TOKEN_LIST_PAGE_LOADED) ? <Route exact path="/tokens/fees" component={TokenFees} /> : null}
              {role.can(userRole, TOKEN_DETAIL_PAGE_LOADED) ? <Route path="/tokens/:symbol" component={TokenDetail} /> : null}
              {role.can(userRole, TOKEN_LIST_PAGE_LOADED) ? <Route path="/tokens" component={Tokens} /> : null}

              {role.can(userRole, CONTRACT_LIST_PAGE_LOADED) ? <Route path="/contracts/create" component={ContractAdd} /> : null}
              {role.can(userRole, CONTRACT_LIST_PAGE_LOADED) ? <Route path="/contracts/:key" component={ContractDetail} /> : null}
              {role.can(userRole, CONTRACT_LIST_PAGE_LOADED) ? <Route path="/contracts" component={Contracts} /> : null}

              {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <Route path="/masteraccounts/create" component={MasterAccountAdd} /> : null}
              {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <Route path="/masteraccounts/:key/update" component={MasterAccountUpdate} /> : null}
              {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <Route path="/masteraccounts/:key/detail" component={MasterAccountDetail} /> : null}
              {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <Route path="/masteraccounts/:key/mint" component={MasterAccountMint} /> : null}
              {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <Route path="/masteraccounts" component={MasterAccounts} /> : null}

              {role.can(userRole, CHAT_CHANNEL_LIST_PAGE_LOADED) ? <Route path="/channels/:key/post/:postkey" component={PostDetail} /> : null}
              {role.can(userRole, CHAT_CHANNEL_LIST_PAGE_LOADED) ? <Route path="/channels/create" component={ChannelAdd} /> : null}
              {role.can(userRole, CHAT_CHANNEL_LIST_PAGE_LOADED) ? <Route path="/channels/:key/edit" component={ChannelEdit} /> : null}
              {role.can(userRole, CHAT_CHANNEL_LIST_PAGE_LOADED) ? <Route path="/channels/:key" component={ChannelDetail} /> : null}
              {role.can(userRole, CHAT_CHANNEL_LIST_PAGE_LOADED) ? <Route path="/channels" component={Channels} /> : null}
              {role.can(userRole, DEPOSIT_BANK_REFERENCE_CODE_SUBMIT) ? <Route path="/deposit" component={DepositWithReferenceCode} /> : null}

              {role.can(userRole, RATES_PAGE_LOADED) ? <Route path="/rates" component={Rates} /> : null}
              {role.can(userRole, RATE_CREATE_PAGE_LOADED) ? <Route path="/rate/create" component={RateAdd} /> : null}
              {role.can(userRole, RATE_UPDATE_PAGE_LOADED) ? <Route path="/rate/:symbol/update" component={RateUpdate} /> : null}
            </Switch>
          </div>
          <div id="footer">
            <strong>Application Version: {applicationVersion}</strong> | <strong> API URL: {API_ROOT_URL}</strong>
            <LogoutPane currentUser={this.props.currentUser} />
          </div>
        </div>
      )
    }
    return (
      <div>
        <div id="header">
          <h1><Link to="/">{this.props.appName}</Link></h1>
        </div>
        <Navigation currentUser={this.props.currentUser} />
      </div>
    )
  }
}

// App.contextTypes = {
//   router: PropTypes.object.isRequired
// }

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js